import { renderTitleNames } from '@utils/notificationUtils'
import { NotificationFollowIcon } from '../NotificationIcons'
import NotificationDisplay from '../NotificationDisplay'


const FollowDisplay = ({ users }) => {

  return (
    <NotificationDisplay
      Icon={NotificationFollowIcon}
      users={users}
      title={<span>{renderTitleNames(users)} followed you!</span>}
    />
  )
}

export default FollowDisplay
